<template>
  <div class="public-product">
    <div class="hander"></div>
    <div>
      <ul class="ul">
        <li>
          <h4>共享产品</h4>
          <p :class="[currentH4 == '共享产品' ? 'changeColor' : '']">
            共享陪护设备
          </p>
        </li>

        <li>
          <h4>平台建设</h4>
          <p :class="[currentH4 == '平台建设' ? 'changeColor' : '']">IOT平台</p>
        </li>

        <!-- <li>
          <h4>硬件开发</h4>
          <p :class="[currentH4 == '硬件开发' ? 'changeColor' : '']">
            秒到通讯模块
          </p>
        </li> -->

        <li>
          <h4>工厂OEM</h4>
          <p :class="[currentH4 == '工厂OEM' ? 'changeColor' : '']">
            共享陪护椅改造套件
          </p>
        </li>
      </ul>
    </div>

    <div class="content1">
      <!-- 共享产品 public  -->
      <public v-if="this.currentH4 == '共享产品'"> </public>

      <!-- 秒到云平台 platform  -->
      <platform v-if="this.currentH4 == '平台建设'"></platform>

      <!-- 硬件开发 hardware -->
      <hardware v-if="this.currentH4 == '硬件开发'"></hardware>

      <!-- 工厂OEM  oem-->
      <oem v-if="this.currentH4 == '工厂OEM'"></oem>
    </div>
  </div>
</template>
<script>
import Hardware from './components/hardware.vue';
import Oem from './components/oem.vue';
import Platform from './components/platform.vue';
import Public from './components/public.vue';
export default {
  components: { Public, Platform, Hardware, Oem },
  name: 'PublicProducts',
  data() {
    return {
      currentDate: new Date(),
      currentH4: '共享产品',
      product: '1',
      lot: '2',
      meassage: '3',
      oem: '4',
    };
  },
  mounted() {
    // 获取.ul里面的li
    const lis = document.querySelectorAll('.ul li');
    // 为每个 li 元素添加点击事件
    lis.forEach((li) => {
      li.addEventListener('click', () => {
        // 获取当前 li 元素中的文本内容
        const text = li.querySelector('h4').textContent;
        console.log('[ text ]-79', text);
        this.currentH4 = text;
      });
    });
  },

  methods: {},
};
</script>
<style scoped>
/* .public-product {
  height: 100;
} */
.hander {
  width: 100%;
  /* background: red; */
  height: 100px;
  display: flex;
}
.hander div {
  flex: 1;
  text-align: left;
  margin-left: 5px;
  /* border: 1px solid black; */
}

.hander div span,
p {
  font-size: 13px;
}

.hander div span {
  padding-right: 10px;
}

.content {
  height: 100%;
  /* background: lawngreen; */
  width: 100%;
  padding: 10px;
}

.time {
  font-size: 13px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer-right p {
  padding-right: 5px;
  font-weight: 550;
  text-align: right;
}

.image {
  width: 100%;
  display: block;
  height: 250px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

/* .card-style {
    width: 200px;
  } */

.ul {
  list-style: none;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.changeColor {
  /* color: #0000cd; */
  color: #066ff4;
}
</style>
